import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SaveCustomerOrderDevices(formData) {
  const response = await $.soap({
    body: {
      SaveCustomerOrderDevices: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        DevicesFormData: formData.devicesFormData,
        OrderFormData: formData.orderFormData,
        OrderId: formData.orderId,
        OrderTypeId: formData.orderTypeId,
        ItPocExists: formData.itPocExists,
        FinPocExists: formData.finPocExists
      }
    },
    blueprint: {
      savedId: '$..ID'
    }
  });

  cleanUpResponse(response);
  return response.savedId;
}
